import './App.scss'
import { Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './components/Home'
import About from './components/About'
import Portfolio from './components/Portfolio'
import Contact from './components/Contact'


function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route index path="about" element={<About />} />
          <Route index path="portfolio" element={<Portfolio />} />
          <Route index path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </>
  )
}

export default App
